// Use the full plotly.js bundle which includes all trace types including mapbox
// The minified bundle may have issues with certain trace types
import Plotly from 'plotly.js/dist/plotly';
import createPlotlyComponent from 'react-plotly.js/factory';

const Plot = createPlotlyComponent(Plotly);

export default Plot;

